
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { GeneralInvoicingTargetEnum } from '@gid/models';
import { JobContact } from '@gid/vue-common/components/ticketing/interface/ticketing';
@Component({
  components: {},
})
export default class CallContacts extends Vue {
  @Prop({ default: null }) jobContacts!: JobContact[];
  @Prop({ default: null }) jobRolesFilter!: GeneralInvoicingTargetEnum[];
  get visibleSingle(): boolean {
    return (
      this.contactList &&
      this.contactList.length == 1 &&
      this.getSingleContactPhoneCount() === 1
    );
  }

  get visibleDropdown(): boolean {
    return (
      this.contactList &&
      (this.contactList.length > 1 || this.getSingleContactPhoneCount() > 1)
    );
  }

  getSingleContactPhoneCount(): number {
    if (!this.contactList || this.contactList.length !== 1) return 0;
    const contact = this.contactList[0];
    return (contact.phone ? 1 : 0) + (contact.mobilePhone ? 1 : 0);
  }

  formatPhone(phone: string): string {
    const match = (phone || '').match(/[+,\d]/g);
    return match ? match.join('') : '';
  }

  handleSingleContact(contact: JobContact): void {
    const phone = contact.mobilePhone || contact.phone;
    if (phone) {
      this.link(`tel:${this.formatPhone(phone)}`);
    }
  }
  get contactList(): JobContact[] {
    if (!this.jobContacts || this.jobContacts.length < 0) return [];
    return this.jobContacts
      .filter((jc) => !!jc.jobRole)
      .filter(
        (jc) =>
          (jc.phone || jc.mobilePhone) &&
          (!this.jobRolesFilter ||
            (jc.jobRole && this.jobRolesFilter.includes(jc.jobRole))),
      )
      .sort((a, b) =>
        (a.lastName || '') < (b.lastName || '')
          ? -1
          : (a.lastName || '') > (b.lastName || '')
          ? 1
          : 0,
      );
  }
  @Emit('call-init')
  callInit() {
    return true;
  }
  link(url: string) {
    window.open(url);
    this.callInit();
  }
}
